import axios from 'axios';
import { from } from 'rxjs';
import { map } from 'rxjs/operators';

const AUTOSUGGEST_BASE_URL = `${ process.env.REACT_APP_AOE_SECURE_WITH_PATH }/api/autoSuggest/`;

export const getCompanies = (organizationId, keyword, size) => (from(
   axios.get(`${ AUTOSUGGEST_BASE_URL }company`, {
      params: {
         organizationId,
         keyword,
         size,
      },
   }),
).pipe(
   map(({ data }) => data && data.map(({ text, id, ...rest }) => ({
      ...rest,
      id,
      name: text,
      label: text,
      value: id,
   }))),
));

export const getJobGroups = (organizationId, companyId, keyword, size) => (from(
   axios.get(`${ AUTOSUGGEST_BASE_URL }jobGroup`, {
      params: {
         organizationId,
         companyId,
         keyword,
         size,
      },
   }),
).pipe(
   map(({ data }) => data && data.map(({ text, id, ...rest }) => ({
      ...rest,
      id,
      name: text,
      label: text,
      value: id,
   }))),
));


export const getContracts = ({ keyword }) => {
   return axios.get(`${ AUTOSUGGEST_BASE_URL }getContracts?keyword=${ keyword }`);
};

export const getJobCategory = ({ keyword }) => {
   return axios.get(`${ AUTOSUGGEST_BASE_URL }getJobCategory?keyword=${ keyword }`);
};
